import Help from '../../core/Help';
import Errored from '../Errored';
import GS from '../../grafsync/grafsync';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { default as React } from 'react';
import AddButton from '../AddButton';
import CancelButton from '../CancelButton';
import PrimaryButton from '../PrimaryButton';
import { globalStyles as styles } from '../style/gstheme';
import TitledTextField from '../TitledTextField';
import { MAX_IRI_LENGTH } from '../utils/constants';
import { sanitiseText, detailedCheckIRI, makeCancelable } from '../utils/utils';

class PrefixDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            isValidIRI: false,
            prefix: "",
            iri: "",
            isErrored: null
        };
        this.cancellable = null;
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    doAddPrefix() {
        this.cancellable = makeCancelable(GS.addPrefix(this.state.prefix, this.state.iri));
        return this.cancellable;
    }

    addPrefix = async () => {
        try {
            await this.doAddPrefix().promise;
            this.props.onAddPrefix(this.state.prefix, this.state.iri);
            this.exitAddPrefix();
        }
        catch (e) {
            if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
        }
    };

    exitAddPrefix = () => {
        this.setState(
            {
                open: false,
                iri: "",
                prefix: ""
            });
    };

    handleIRIChange = event => {
        const t = event.target;
        const text = sanitiseText(t.value.trim());
        this.setState({
            isValidIRI: false,
            iri: text
        }, () => {
            const isDuplicateIRI = this.props.prefixes.some(prefixInfo => prefixInfo.iri === text);
            // Only allow one hash at most
            let isValidIRI = true;
            if (text.length === 0 || !detailedCheckIRI(text)) {
                isValidIRI = false;
            }
            if (!(text.endsWith("/") || text.endsWith("#"))) isValidIRI = false;
            if (text.toLowerCase().includes("graphifi")) isValidIRI = false;
            this.setState({
                isValidIRI,
                isDuplicateIRI
            });
        });
    };

    handlePrefixChange = event => {
        const t = event.target;
        const text = sanitiseText(t.value.trim());
        const re = new RegExp("^[a-zA-Z0-9-]*$");
        const isValidPrefix = re.test(text);
        if (!isValidPrefix) return;
        const isDuplicatePrefix = this.props.prefixes.some(prefixInfo => prefixInfo.prefix === text);
        this.setState({
            prefix: text,
            isDuplicatePrefix
        });
    };

    render() {

        const { classes } = this.props;
        const { iri, isValidIRI, isDuplicatePrefix, isDuplicateIRI, prefix, isErrored } = this.state;

        if (isErrored) return <Errored data={isErrored} />;

        return (
            <React.Fragment>
                <AddButton dataTest="add-prefix" title="Add prefix" onClick={this.handleClickOpen} />
                <Dialog
                    data-test="add-iri-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    open={this.state.open}
                    onClose={this.exitAddPrefix}
                    aria-labelledby="iri-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="iri-dialog-title">Add Prefix</DialogTitle>
                    <DialogContent>
                        <Help textRef="ADD_PREFIX" />
                        <form autoComplete="off" noValidate="novalidate">
                            <TitledTextField
                                dataTest="prefix"
                                name="prefix"
                                title="Prefix"
                                required={true}
                                text={prefix}
                                autoFocus={true}
                                placeholder="Enter a prefix"
                                maxLength={20}
                                helperText={
                                    isDuplicatePrefix ?
                                        "This prefix already exists. Please change."
                                        :
                                        ""}
                                onChange={this.handlePrefixChange} />
                            <TitledTextField
                                dataTest="iri"
                                name="iri"
                                title="IRI"
                                margin={true}
                                required={true}
                                text={iri}
                                placeholder="Enter an IRI"
                                maxLength={MAX_IRI_LENGTH}
                                helperText={
                                    iri !== "" && !isValidIRI ?
                                        "This is not a valid prefix IRI"
                                        :
                                        isDuplicateIRI ?
                                            "This IRI already exists. Please change."
                                            :
                                            ""}
                                onChange={this.handleIRIChange} />
                        </form>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitAddPrefix} />
                        <PrimaryButton
                            disabled={!isValidIRI || isDuplicatePrefix || isDuplicateIRI || prefix === ""}
                            onClick={this.addPrefix}>Add</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

PrefixDialog.defaultPros = {
    prefixes: []
};

PrefixDialog.propTypes = {
    prefixes: PropTypes.array,
    onAddPrefix: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(PrefixDialog);